<template>
  <div>
    <div class="row">
      <div class="col-sm-12" v-html="blockData.header"></div>
    </div>
    <component :is="blockData.type" v-bind:chartLabels="this.chartLabels" v-bind:dataValues="this.dataValues"
      v-bind:axisLabel="this.blockData.axis_label">
    </component>
    <div class="row">
      <div class="col-sm-12" v-html="blockData.footer"></div>
    </div>
  </div>
</template>

<script>
import bar from './charts/BlockBar.vue';
import pie from './charts/BlockPie.vue';

export default {
  components: {
    bar,
    pie
  },
  props: {
    blockData: Object
  },
  computed: {
    dataValues: function () {
      let dataValuesArray = [];
      this.blockData.rows.forEach(function (row) {
        dataValuesArray.push(row.value);
      });
      return dataValuesArray;
    },
    chartLabels: function () {
      let chartLabelsArray = [];
      this.blockData.rows.forEach(function (row) {
        chartLabelsArray.push(row.label);
      });
      return chartLabelsArray;
    }
  }
}
</script>
